export default __webpack_public_path__ + "02d12fa0b61b3f4d1ff57dd6f2623ac9.png";